import React from 'react';
import { Grid } from '@material-ui/core';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { FieldValues } from '../IMSFormFieldsTypes';

interface Component {
  id: React.Key | null | undefined;
  label_display: any;
  label: any;
  is_auto_populated?: boolean;
  datatype: string;
  values?: { id: React.Key | null | undefined; value: any }[];
  component_response?: any;
}

interface Group {
  id: React.Key | null | undefined;
}

interface IMSFormAccordionCheckboxGroupProps {
  component: Component;
  group: Group;
  fieldValues: FieldValues;
  handleFieldChange: (groupId: string | number, componentId: string | number, value: any, datatype: string) => void;
  shouldShowAutoPopulatedIndicator: (component: any, fieldValues: FieldValues) => boolean;
}

const IMSFormAccordionCheckboxGroup: React.FC<IMSFormAccordionCheckboxGroupProps> = ({
  component,
  group,
  fieldValues,
  handleFieldChange,
  shouldShowAutoPopulatedIndicator,
}) => {
  const AutoPopulateIndicator = () => (
    <FiberManualRecordIcon
      sx={{
        position: 'absolute',
        left: -30,
        top: '50%',
        transform: 'translateY(-50%)',
        color: '#209b2e',
        fontSize: '20px',
      }}
      titleAccess="Auto-populated from VIN"
    />
  );

  return (
    <div style={{ position: 'relative', width: '100%' }}>
      {typeof component.id === 'number' &&
        shouldShowAutoPopulatedIndicator(
          {
            is_auto_populated: component.is_auto_populated,
            id: component.id as number,
            component_response: component.component_response,
          },
          fieldValues
        ) && <AutoPopulateIndicator />}
      <div style={{ marginTop: '30px', marginBottom: '30px' }}>
        <div style={{ marginBottom: '5px' }}>
          <label style={{ margin: '0' }}>
            {component.label_display || component.label}
          </label>
        </div>

        <Grid container alignItems="center">
          {component.values?.map((option) => (
            <div key={option.id} style={{ width: '100%' }}>
              <Grid container alignItems="center">
                <input
                  type="checkbox"
                  id={option.id != null ? String(option.id) : undefined}
                  checked={
                    option.id != null
                      ? fieldValues[String(option.id)]?.value === true ||
                        fieldValues[String(option.id)] === true ||
                        fieldValues[String(option.id)]?.value === 'true' ||
                        fieldValues[String(option.id)] === 'true'
                      : false
                  }
                  style={{ color: '#4f2682', marginLeft: '5px' }}
                  onChange={(event) =>
                    option.id != null &&
                    group.id != null &&
                    handleFieldChange(
                      String(group.id),
                      String(option.id),
                      event.target.checked,
                      component.datatype
                    )
                  }
                />
                <label
                  htmlFor={typeof option.value === 'string' ? option.value : undefined}
                  style={{
                    color: '#4f2682',
                    marginLeft: '5px',
                    marginBottom: '0',
                  }}
                >
                  {option.value}
                </label>
              </Grid>
            </div>
          ))}
        </Grid>
      </div>
    </div>
  );
};

export default IMSFormAccordionCheckboxGroup;
